import { render, staticRenderFns } from "./registration-forms.page.vue?vue&type=template&id=6cf75922&scoped=true&"
import script from "./registration-forms.page.vue?vue&type=script&lang=js&"
export * from "./registration-forms.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf75922",
  null
  
)

export default component.exports